import React, { useEffect, useState } from 'react'
import CountersSummaryChart from '../ChartsImpl/HomePageCharts/CountersSummaryChart'
import { Link } from 'react-router-dom'
import axios from 'axios'
import toast, { Toaster } from "react-hot-toast";
import { ShimmerThumbnail } from "react-shimmer-effects";

const CountersSummary = () => {

    const [branchNamesList, setBranchNamesList] = useState([]);
    const [servingCounters, setServingCounters] = useState([]);
    const [idleCounters, setIdleCounters] = useState([]);
    const [notAvailableCounters, setNotAvailableCounters] = useState([]);
    const [auxCounters, setAuxCounters] = useState([]);

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    let userDetails = JSON.parse(localStorage.getItem("user_details"));

    const [data, setData] = useState(null);
    const [allDataLoaded, setAllDataLoaded] = useState(false);

    useEffect(() => {
        getCountersSummaryData();
    }, [CountersSummary])

    useEffect(() => {
        if (data !== null) {
            const callFunction = () => {
                getCountersSummaryData();
            };

            const interval = setInterval(callFunction, 60000);

            return () => clearInterval(interval);
        }
    }, [data]);

    const getCountersSummaryData = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/branch/${userDetails['bid']}/counters-summary`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getCountry success');
            let data = res.data.data;
            console.log("data 1: ", data);
            extractSummaryDetails(data.branchCountersCount);
            setData(data);
            setAllDataLoaded(true);

        }).catch((error) => {
            console.log('getCountry error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        })
    }

    const extractSummaryDetails = (summary) => {
        const branchNames = [];
        const servingCunters = [];
        const idleCounters = [];
        const unavailableCounters = [];
        const auxCounters = [];

        summary.forEach(element => {
            branchNames.push(element.branchName);
            servingCunters.push(element.servingCounters);
            idleCounters.push(element.idleCounters);
            unavailableCounters.push(element.totalCounters - (element.idleCounters + element.servingCounters));
            auxCounters.push(element.auxCounters);
        })

        setBranchNamesList(branchNames);
        setServingCounters(servingCunters);
        setIdleCounters(idleCounters);
        setNotAvailableCounters(unavailableCounters);
        setAuxCounters(auxCounters)
    }

    return (
        <>
            {!allDataLoaded ? (
                <div className="container-fluid">
                    <div className="block-header">
                        <div className="row clearfix">
                            <div className="col-md-6 col-sm-12">
                                <h2>Counters Summary</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row clearfix">
                        {/* <Barchart /> */}
                        {Array.from({ length: 4 }).map((_, index) => (
                            <div className="col-lg-3 col-md-6" key={index}>
                                <ShimmerThumbnail>
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">

                                                </div>
                                            </div>
                                            <div className="text-right" style={{ textAlign: 'right' }}>
                                                <h6>All Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </ShimmerThumbnail>
                            </div>
                        ))}
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-6">
                            <ShimmerThumbnail>
                                <div className={`card landing-page-main-cards"}`}></div>
                            </ShimmerThumbnail>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    {data ? (
                        <div className="container-fluid">
                            <div className="block-header">
                                <div className="row clearfix">
                                    <div className="col-md-6 col-sm-12">
                                        <h2>Counters Summary</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row clearfix">
                                {/* <Barchart /> */}
                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    {data.totalCounters}
                                                </div>
                                            </div>
                                            <div className="text-right" style={{ textAlign: 'right' }}>
                                                <h6>All Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    {data.totalServingCounters}
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <h6>Serving Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    {data.totalIdleCounters}
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <h6>Idle Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    {data.totalAuxCounters}
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <h6>AUX Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-lg-12 col-md-6">
                                    {
                                            branchNamesList.length > 0 &&
                                            servingCounters.length > 0 &&
                                            idleCounters.length > 0 &&
                                            auxCounters.length > 0 &&
                                            notAvailableCounters.length > 0 ? (
                                            <CountersSummaryChart branchNamesList={branchNamesList} servingCounters={servingCounters}
                                                idleCounters={idleCounters} notAvailableCounters={notAvailableCounters} auxCounters={auxCounters} />
                                        ) : (
                                            null
                                        )
                                    }

                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="container-fluid">
                            <div className="block-header">
                                <div className="row clearfix">
                                    <div className="col-md-6 col-sm-12">
                                        <h2>Counters Summary</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row clearfix">
                                {/* <Barchart /> */}
                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    0
                                                </div>
                                            </div>
                                            <div className="text-right" style={{ textAlign: 'right' }}>
                                                <h6>All Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    0
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <h6>Serving Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    0
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <h6>Idle Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6">
                                    <div
                                        className={`card landing-page-main-cards"}`}
                                    >
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    0
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <h6>AUX Counters</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-lg-12 col-md-6">
                                    {
                                        branchNamesList.length > 0 &&
                                            servingCounters.length > 0 &&
                                            idleCounters.length > 0 &&
                                            auxCounters.length > 0 &&
                                            notAvailableCounters.length > 0 ? (
                                            <CountersSummaryChart branchNamesList={branchNamesList} servingCounters={servingCounters}
                                                idleCounters={idleCounters} notAvailableCounters={notAvailableCounters} auxCounters={auxCounters} />
                                        ) : (
                                            null
                                        )
                                    }

                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

        </>
    )
}

export default CountersSummary